export default __webpack_public_path__ + "static/media/maa-amet-logo_eng.2f92eed8.svg";